var $aff8cf7fb0e74c83$exports = {};
$aff8cf7fb0e74c83$exports = {
    "colorFormat": `Format barv`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$aff8cf7fb0e74c83$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
